
   import Vue from 'vue'
   import { MultiSelect } from '@/components/input'

   export default Vue.extend({
      name: 'MultiSelectFormGroup',
      props: {
         id: String,
         label: String,
         value: {
            type: Array as () => string[],
            default: () => [] as string[],
         },
         options: {
            type: Array as () => NameValuePair[],
            default: () => [] as NameValuePair[],
         },
         size: { type: String, default: 'btn-sm' },
         maxSelections: {
            type: Number,
            default: 6,
         },
         nonSelectedText: {
            type: String,
            default: 'None selected',
         },
         allSelectedText: {
            type: String,
            default: 'All selected',
         },
         showSelectAll: {
            type: Boolean,
            default: false,
         },
         showSearch: {
            type: Boolean,
            default: false,
         },
         required: {
            type: Boolean,
            default: false,
         },
         readonly: {
            type: Boolean,
            default: false,
         },
         vertical: {
            type: Boolean,
            default: false,
         },
      },
      components: {
         MultiSelect,
      },
      data() {
         return {
            initialValue: [] as string[],
            innerValue: [] as string[],
            dirty: false,
         }
      },
      computed: {
         helpBlock(): string {
            return `A value for ${this.label} is required`
         },
         validationFailed(): boolean {
            return this.required && this.dirty && this.empty
         },
         empty(): boolean {
            return !!this.innerValue && this.innerValue.length === 0
         },
         showHelpBlock(): boolean {
            return this.validationFailed || (this.required && this.empty)
         },
      },
      methods: {
         onChange() {
            if (!this.dirty) {
               this.dirty = !this.arraysAreEqual(this.innerValue, this.initialValue)
            }
            this.$emit('input', this.innerValue)
         },
         arraysAreEqual(a: string[], b: string[]) {
            if (!a || !b) {
               return false
            }
            return a.containsSameElementsAs(b)
         },
      },
      watch: {
         value(newValue: string[]) {
            if (!this.arraysAreEqual(newValue, this.innerValue)) {
               this.innerValue = newValue
               this.initialValue = newValue
            }
         },
      },
      mounted() {
         this.innerValue = this.value
         this.initialValue = this.value
      },
   })
